<div class="toolbar-container -with-dropdown">
  <div class="toolbar toolbar_empty-title">
    <ul class="toolbar-items">
      <li class="toolbar-item">
        <button type="button -primary"
          class="form-configuration--reset button"
          (click)="resetToDefault($event)">
          <op-icon icon-classes="button--icon icon-undo" />
          <span class="button--text" [textContent]="text.reset"></span>
        </button>
      </li>
      @if (typeBanner.eeAvailable) {
        <li
          class="toolbar-item drop-down">
          <a class="form-configuration--add-group button -primary" aria-haspopup="true">
            <op-icon icon-classes="button--icon icon-add" />
            <span class="button--text" [textContent]="text.label_group"></span>
            <op-icon icon-classes="button--dropdown-indicator" />
          </a>
          <ul class="menu-drop-down-container">
            <li>
              <button
                type="button"
                class="menu-item form-configuration--add-group"
                [textContent]="text.add_group"
                (click)="createGroup('attribute', '')"
                >
              </button>
            </li>
            <li>
              <button
                type="button"
                class="menu-item form-configuration--add-group"
                [textContent]="text.add_table"
                (click)="addGroupAndOpenQuery()"
                >
              </button>
            </li>
          </ul>
        </li>
      }
    </ul>
  </div>
</div>

<div class="grid-block wrap">
  <div class="grid-content small-12 medium-6">
    <div id="draggable-groups" dragula="groups" [(dragulaModel)]="groups">
      @for (group of groups; track group) {
        @if (group.type === 'attribute') {
          <op-type-form-attribute-group (removeAttribute)="deactivateAttribute($event)"
            (deleteGroup)="deleteGroup(group)"
            [group]="group" />
        }
        @if (group.type === 'query') {
          <op-type-form-query-group (editQuery)="editQuery(group)"
            (deleteGroup)="deleteGroup(group)"
            [group]="group" />
        }
      }
    </div>
  </div>
  <div class="grid-content small-12 medium-6">
    <div id="type-form-conf-inactive-group">
      <div class="group-head">
        <span class="group-name" [textContent]="text.label_inactive"></span>
        &ngsp;
        <span class="advice" [textContent]="text.drag_to_activate"></span>
      </div>
      <div class="attributes" dragula="attributes" [(dragulaModel)]="inactives">
        @for (inactive_attribute of inactives; track inactive_attribute) {
          <div
            class="type-form-conf-attribute"
            [attr.data-key]="inactive_attribute.key">
            <span class="attribute-handle icon-drag-handle"></span>
            <span class="attribute-name">
              {{ inactive_attribute.translation }}
              @if (inactive_attribute.is_cf) {
                <span
                  class="attribute-cf-label"
                  [textContent]="text.custom_field">
                </span>
              }
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div><!-- END type form configurator -->
